import * as OFMSUI from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { Field, useFormik, FormikProvider, ErrorMessage, FieldArray } from "formik"; import * as Yup from "yup"; import React, { useState } from "react"; import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { AlphaNumericValidation, DashboardServiceReport, handleFileChange, LabelHeader, ModuleHeader, NumberValidation, todayDate } from "../../utils/commonFunctions"; import { store } from "../../../App"; import ShowAlert from "../../alert"; import { Form, Table } from "react-bootstrap";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai"; import moment from "moment-timezone";
import Swal from "sweetalert2";
import ClassificationHeads from "./ClassificationHeads";
const GenerationPayment = () => {

    const [transactionId, setTransactionId] = useState(""); const [bankNamesList, setbankNamesList] = useState([]); const [bankList, setbankList] = useState([]); const [headNamesList, setheadNamesList] = useState([]); const [subheadOptions, setSubheadOptions] = useState({});
    const [rowdata, saveRowData] = useState([])
    const defaulttodayDate = new Date().toISOString().split("T")[0];


    const validationSchema = Yup.object().shape({
        receiptno: Yup.string().required("Required"), date: Yup.string().required("Required"), cash_bank: Yup.string().required("Required"), paymentamount: Yup.string().required("Required"), balance_in_account: Yup.number(), banknameaccountno: Yup.string().required("Required"),
        name: Yup.string().required("Required"), mode: Yup.string().required("Required"), receipt_description: Yup.string().required("Required"), cheque_dd_receipt_no: Yup.string().required("Required"), file: Yup.string().required("Required"),
        dummy_journal_voucher_heads_Req: Yup.array().of(
            Yup.object().shape({
                headid: Yup.string().required("Required"),
                debit: Yup.number()
                    .typeError("Amount must be a number")
                    .required("Required")
                    .min(0, "Amount must be greater than or equal to 0"),
            })
        )
    });



    const showNotification = (type, message) => { if (type === "success") { Swal.fire("Success", message, "success"); } else if (type === "error") { Swal.fire("Error", message, "error"); } else if (type === "warning") { Swal.fire("Warning", message, "warning"); } else if (type === "info") { Swal.fire("info", message, "info"); } };

    const formik = useFormik({
        initialValues: {
            payment_receipt_id: "", receiptno: "", date: defaulttodayDate, cash_bank: "", banknameaccountno: "", balance_in_account: "", paymentamount: "", name: "", mode: "", receipt_description: "", cheque_dd_receipt_no: "", file: "", dummy_journal_voucher_heads_Req: [{ headid: "", subheadid: "", debit: "" }],
        },
        validationSchema: validationSchema,
        // onSubmit: (values) => {
        //     const validSubHeads = values.dummy_journal_voucher_heads_Req.filter(
        //         (item) => item.headid && item.subheadid && item.debit
        //     );

        //     //  Duplicate subhead check
        //     const seen = new Set();
        //     const duplicates = [];

        //     validSubHeads.forEach((item) => {
        //         const key = `${item.headid}-${item.subheadid}`;
        //         if (seen.has(key)) {
        //             duplicates.push(key);
        //         } else {
        //             seen.add(key);
        //         }
        //     });

        //     if (duplicates.length > 0) {
        //         showNotification("warning", "Duplicate Subheadnames Found. Please remove duplicates before submission.");
        //         return;
        //     }
        //     let params = { "receiptno": values.receiptno?.trim(), "fromDate": moment(values.date).format("DD-MM-YYYYY") };
        //     HousingService.CheckReceipNo(params).then((res) => {
        //         if (res.data[0].receipt_exists === true) {
        //             showNotification("warning", "Voucher No. already exists. Please use a different Voucher No.");
        //         }
        //     }).catch((error) => {
        //         ShowAlert("Some error occurred", "error"); console.log(error);
        //     }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

        //     const totalDebit = formik.values.dummy_journal_voucher_heads_Req.reduce((sum, item) => {
        //         const debitValue = parseFloat(item.debit) || 0;
        //         return sum + debitValue;
        //     }, 0);


        //     const paymentAmount = parseFloat(values.paymentamount || 0);
        //     const balanceInAccount = parseFloat(values.balance_in_account || 0);

        //     if (paymentAmount === 0) {
        //         showNotification("warning", "Payment Amount Cannot be 0");
        //         return;
        //     }
        //     if (paymentAmount > balanceInAccount) {
        //         showNotification("warning", "Payment Amount must be less than or equal to Balance in Account.");
        //         return;
        //     }



        //     if (paymentAmount == totalDebit) {
        //         Swal.fire({
        //             text: "Do you want Submit?",
        //             icon: "success",
        //             showCancelButton: true,
        //             confirmButtonColor: "#3085d6",
        //             cancelButtonColor: "#d33",
        //             confirmButtonText: "Yes",
        //         }).then((result) => {
        //             if (result.isConfirmed) {
        //                 let file = document.getElementById("file").files[0]; let formData = new FormData(); formData.append("file", file);
        //                 HousingService.fileUploadUrl(formData).then((respose) => {
        //                     if (respose.data) {
        //                         let params = {
        //                             payment_receipt_id: values.payment_receipt_id, receiptno: values.receiptno, date: moment(values.date).format("YYYY-MM-DD"), cash_bank: values.cash_bank, banknameaccountno: values.banknameaccountno, paymentamount: values.paymentamount, remaining_balance: values.balance_in_account, name: values.name, mode: values.mode, cheque_dd_receipt_no: values.cheque_dd_receipt_no, receipt_description: values.receipt_description, no_of_subheads: validSubHeads.length, upload_copy: respose.data, dummy_journal_voucher_heads_Req: values.dummy_journal_voucher_heads_Req
        //                         };
        //                         HousingService.Generation_Payment_Insertion(params).then((response) => {
        //                             if (response?.data?.SCODE === "01") {
        //                                 showNotification("success", "Submitted successfully");
        //                                 getPdf(values.payment_receipt_id);
        //                             }
        //                             else if (response?.data?.SCODE === "04") {
        //                                 showNotification("warning", response?.data?.SDESC);
        //                             }
        //                             else {
        //                                 showNotification("error", response?.data?.SDESC);
        //                             }
        //                         })
        //                     }
        //                 }).catch((error) => {
        //                     ShowAlert("Some error occurred", "error"); console.log(error);
        //                 }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
        //             }
        //         });
        //     }
        //     else {
        //         showNotification("warning", "Total Subheads Amount must be Equal to Payment amount");
        //     }


        // }
        onSubmit: async (values) => {

            const validSubHeads = values.dummy_journal_voucher_heads_Req.filter(
                (item) => item.headid && item.subheadid && item.debit
            );

            // Duplicate check
            const seen = new Set();
            const duplicates = [];

            validSubHeads.forEach((item) => {
                const key = `${item.headid}-${item.subheadid}`;
                if (seen.has(key)) {
                    duplicates.push(key);
                } else {
                    seen.add(key);
                }
            });

            if (duplicates.length > 0) {
                showNotification("warning", "Duplicate Subheadnames Found.");
                return;
            }

            try {
                let params = {
                    receiptno: values.receiptno?.trim(),
                    fromDate: moment(values.date).format("DD-MM-YYYY"),
                    transaction_type:"P" 
                    // FIXED (extra Y removed)
                };

                const res = await HousingService.CheckReceipNo(params);

                if (res.data[0].receipt_exists === true) {
                    showNotification("warning", "Voucher No. already exists for the selected Payment Date.");
                    return; 
                }

            } catch (error) {
                ShowAlert("Some error occurred", "error");
                console.log(error);
                return;
            }

            // Continue only if receipt is NOT duplicate

            const totalDebit = values.dummy_journal_voucher_heads_Req.reduce((sum, item) => {
                return sum + (parseFloat(item.debit) || 0);
            }, 0);

            const paymentAmount = parseFloat(values.paymentamount || 0);
            const balanceInAccount = parseFloat(values.balance_in_account || 0);

            if (paymentAmount === 0) {
                showNotification("warning", "Payment Amount Cannot be 0");
                return;
            }

            if (paymentAmount > balanceInAccount) {
                showNotification("warning", "Payment Amount must be ≤ Balance.");
                return;
            }

            if (paymentAmount !== totalDebit) {
                showNotification("warning", "Total Subheads Amount must equal Payment amount");
                return;
            }

            Swal.fire({
                text: "Do you want Submit?",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "Yes",
            }).then(async (result) => {
                if (result.isConfirmed) {

                    try {
                        let file = document.getElementById("file").files[0];
                        let formData = new FormData();
                        formData.append("file", file);

                        const uploadRes = await HousingService.fileUploadUrl(formData);

                        if (uploadRes.data) {
                            let params = {
                                payment_receipt_id: values.payment_receipt_id,
                                receiptno: values.receiptno,
                                date: moment(values.date).format("YYYY-MM-DD"),
                                cash_bank: values.cash_bank,
                                banknameaccountno: values.banknameaccountno,
                                paymentamount: values.paymentamount,
                                remaining_balance: values.balance_in_account,
                                name: values.name,
                                mode: values.mode,
                                cheque_dd_receipt_no: values.cheque_dd_receipt_no,
                                receipt_description: values.receipt_description,
                                no_of_subheads: validSubHeads.length,
                                upload_copy: uploadRes.data,
                                dummy_journal_voucher_heads_Req: values.dummy_journal_voucher_heads_Req
                            };

                            const response = await HousingService.Generation_Payment_Insertion(params);

                            if (response?.data?.SCODE === "01") {
                                showNotification("success", "Submitted successfully");
                                getPdf(values.payment_receipt_id);
                            } else if (response?.data?.SCODE === "04") {
                                showNotification("warning", response?.data?.SDESC);
                            } else {
                                showNotification("error", response?.data?.SDESC);
                            }
                        }

                    } catch (error) {
                        ShowAlert("File name should not contain symbols or special characters", "error");
                        console.log(error);
                    } finally {
                        store.dispatch({ type: "HIDE_SPINNER" });
                    }
                }
            });
        }
    });
    const getPdf = (payment_receipt_id) => {
        HousingService.getPaymentPdf(payment_receipt_id).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); let tab = window.open(); tab.location.href = url; setTimeout(() => { window.location.reload(); }, 2000);
        });
    };

    React.useEffect(() => {
        let params = { save_flag_Payment_Receipts_Journal: "Payment" };
        HousingService.getPaymentReceiptId(params).then((res) => { const id = res.data[0].payment_receipt_id; setTransactionId(id); formik.setFieldValue("payment_receipt_id", id); });
        HousingService.fetchBank().then((res) => {
            if (res.data) {
                setbankList(res.data);
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.banknameaccountno}> {item.banks} </option>
                    );
                });
                setbankNamesList(options);
            }
        });

        HousingService.fetchHeadNamesDropdowns().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.headid}> {item.heads} </option>
                    );
                });
                setheadNamesList(options);
            }
        });
        HousingService.ClassificationBudget().then((res) => { saveRowData(res.data); });

    }, [])

    const getBankBalance = (e) => {
        const selectedValue = e.target.value;
        console.log("e.target.value", selectedValue);

        if (selectedValue !== "") {
            const matchedItem = bankList.find(item => item.banknameaccountno === selectedValue);

            if (matchedItem) {
                formik.setFieldValue("balance_in_account", matchedItem.remaining_balance);
            } else {
                formik.setFieldValue("balance_in_account", "");
            }
        } else {
            formik.setFieldValue("balance_in_account", "");
        }
    };




    const getSubheads = (e, index) => {
        const selectedHeadId = e.target.value;

        if (!selectedHeadId) {
            setSubheadOptions((prev) => ({
                ...prev,
                [index]: []
            }));
            formik.setFieldValue(`dummy_journal_voucher_heads_Req[${index}].subheadid`, '');
            formik.setFieldValue(`dummy_journal_voucher_heads_Req[${index}].debit`, '');
            return;
        }
        HousingService.fetchSubHeadName(selectedHeadId).then((res) => {
            if (res.data) {
                const options = res.data.map((item) => ({ value: item.subheadseqid, label: item.subheads }));
                setSubheadOptions((prev) => ({ ...prev, [index]: options }));
            }
        });
    };



    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Generation Of Payment Voucher" />
            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <DashboardServiceReport title="Service" />
                        {/* <ClassificationHeads /> */}
                        <OFMSUI.Row className="p-4">
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Transaction ID No" />
                                <Field value={transactionId} name="payment_receipt_id" className={formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? "form-control is-invalid" : "form-control"} type="text" disabled={true} />
                                {formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? (<div className="invalid-feedback"> {formik.errors.payment_receipt_id} </div>) : null}
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Voucher No." />
                                <Field name="receiptno" placeholder="Enter Voucher No" className={formik.touched.receiptno && formik.errors.receiptno ? "form-control is-invalid" : "form-control"} type="text" maxLength={10}
                                    onKeyPress={(e) => AlphaNumericValidation(e)}
                                    onCopy={(e) => e.preventDefault()}
                                    onPaste={(e) => e.preventDefault()}
                                    onCut={(e) => e.preventDefault()}
                                />
                                {formik.touched.receiptno && formik.errors.receiptno ? (<div className="invalid-feedback">{formik.errors.receiptno}</div>) : null}
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Payment Date" />
                                <Field name="date" className={formik.touched.date && formik.errors.date ? "form-control is-invalid" : "form-control"} type="date" max={todayDate} min="2024-01-01" />
                                {formik.touched.date && formik.errors.date ? (<div className="invalid-feedback">{formik.errors.date}</div>) : null}
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Type of Transaction" />
                                <Field component="select" name="cash_bank" className={formik.touched.cash_bank && formik.errors.cash_bank ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    <option value="Bank">Bank</option>
                                    {/* <option value="Cash">Cash</option> */}
                                </Field>
                                {formik.touched.cash_bank && formik.errors.cash_bank ? (<div className="invalid-feedback">{formik.errors.cash_bank}</div>) : null}
                            </OFMSUI.Col>
                            {formik.values.cash_bank === "Bank" && (
                                <>
                                    <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                        <LabelHeader title="Bank Name/Account No" />
                                        <Field component="select" name="banknameaccountno" className={formik.touched.banknameaccountno && formik.errors.banknameaccountno ? "form-control is-invalid" : "form-control"}
                                            onChange={(e) => { getBankBalance(e); formik.handleChange(e) }}
                                        >
                                            <option value="">Select</option>
                                            {bankNamesList}
                                        </Field>
                                        {formik.touched.banknameaccountno && formik.errors.banknameaccountno ? (<div className="invalid-feedback">{formik.errors.banknameaccountno}</div>) : null}
                                    </OFMSUI.Col>
                                    <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                        <LabelHeader title="Bank Balance" />
                                        <Field
                                            name="balance_in_account" placeholder="Enter Bank Balance" className={formik.touched.balance_in_account && formik.errors.balance_in_account ? "form-control is-invalid" : "form-control"} type="text" disabled={true} />
                                        {formik.touched.balance_in_account && formik.errors.balance_in_account ? (<div className="invalid-feedback"> {formik.errors.balance_in_account} </div>) : null}
                                    </OFMSUI.Col>

                                </>
                            )}
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Payment amount" />
                                <Field name="paymentamount" placeholder="Enter Payment amount" className={formik.touched.paymentamount && formik.errors.paymentamount ? "form-control is-invalid" : "form-control"} type="text" maxLength={15} onKeyPress={(e) => NumberValidation(e)}/>
                                {formik.touched.paymentamount && formik.errors.paymentamount ? (<div className="invalid-feedback">{formik.errors.paymentamount}</div>) : null}
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Amount Paid To" />
                                <Field name="name" placeholder="Enter Amount Paid To" className={formik.touched.name && formik.errors.name ? "form-control is-invalid" : "form-control"} type="text" />
                                {formik.touched.name && formik.errors.name ? (<div className="invalid-feedback">{formik.errors.name}</div>) : null}
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Description of Payment" />
                                <Field name="receipt_description" placeholder="Enter Description of Payment" className={formik.touched.receipt_description && formik.errors.receipt_description ? "form-control is-invalid" : "form-control"} as="textarea" />
                                {formik.touched.receipt_description && formik.errors.receipt_description ? (<div className="invalid-feedback">{formik.errors.receipt_description}</div>) : null}
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="Payment Mode" />
                                <Field component="select" name="mode" className={formik.touched.mode && formik.errors.mode ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    <option value="Cheque/DD/ReceiptNo"> Cheque/DD/ReceiptNo </option>
                                    <option value="DD">DD</option>
                                    <option value="Online"> Online </option>
                                </Field>
                                {formik.touched.mode && formik.errors.mode ? (<div className="invalid-feedback">{formik.errors.mode}</div>) : null}
                            </OFMSUI.Col>
                            {formik.values.mode != "" && (
                                <>
                                    <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                        <LabelHeader title={
                                            formik.values.mode === "Cheque/DD/ReceiptNo"
                                                ? "Cheque/DD/ReceiptNo"
                                                : formik.values.mode === "DD"
                                                    ? "DD"
                                                    : "Online"
                                        } />
                                        <Field name="cheque_dd_receipt_no" placeholder="Enter Cheque/DD/ReceiptNo" className={formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? "form-control is-invalid" : "form-control"} type="text" />
                                        {formik.touched.cheque_dd_receipt_no && formik.errors.cheque_dd_receipt_no ? (<div className="invalid-feedback">{formik.errors.cheque_dd_receipt_no}</div>) : null}
                                    </OFMSUI.Col>

                                </>
                            )}
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                                <LabelHeader title="File Upload (File name should not contain symbols or special characters.)" />
                                <div className="input-group">
                                    <Field type="file" name="file" id="file" className={formik.touched.file && formik.errors.file ? "form-control is-invalid" : "form-control"} accept="application/pdf" onChange={(e) => { handleFileChange(e); formik.handleChange(e) }} />
                                    <ErrorMessage name="file" component={"div"} className="text-error" />
                                </div>
                                {formik.touched.file && formik.errors.file ? (<div className="invalid-feedback">{formik.errors.file}</div>) : null}
                            </OFMSUI.Col>
                        </OFMSUI.Row>
                        <OFMSUI.Row className="px-4 m-0">
                            <FieldArray name="dummy_journal_voucher_heads_Req">
                                {({ push, remove }) => (
                                    <Table striped bordered hover>
                                        <thead className="fw-bold">
                                            <tr className="table_countshead">
                                                <td style={{ width: "1%" }}>S.No</td>
                                                <td style={{ width: "50%" }}>Heads Name</td>
                                                <td>SubHeads Name</td>
                                                <td style={{ width: "20%" }}>Amount</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formik.values.dummy_journal_voucher_heads_Req.map((_, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <Field
                                                            as="select"
                                                            name={`dummy_journal_voucher_heads_Req[${index}].headid`}
                                                            className={`form-control ${formik.touched.dummy_journal_voucher_heads_Req?.[index]?.headid &&
                                                                formik.errors.dummy_journal_voucher_heads_Req?.[index]?.headid
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            onChange={(e) => {
                                                                getSubheads(e, index); // pass index
                                                                formik.handleChange(e);

                                                            }}
                                                            onCopy={(e) => e.preventDefault()}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onCut={(e) => e.preventDefault()}
                                                        >
                                                            <option value="">Select</option>
                                                            {headNamesList}
                                                        </Field>

                                                        <ErrorMessage
                                                            name={`dummy_journal_voucher_heads_Req[${index}].headid`}
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </td>

                                                    {/* SubHead Field */}
                                                    <td>
                                                        <Field
                                                            as="select"
                                                            name={`dummy_journal_voucher_heads_Req[${index}].subheadid`}
                                                            className={`form-control ${formik.touched.dummy_journal_voucher_heads_Req?.[index]?.subheadid &&
                                                                formik.errors.dummy_journal_voucher_heads_Req?.[index]?.subheadid
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                        >
                                                            <option value="">--Select--</option>
                                                            {(subheadOptions[index] || []).map((option, i) => (
                                                                <option key={i} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))}
                                                        </Field>

                                                        <ErrorMessage
                                                            name={`dummy_journal_voucher_heads_Req[${index}].subheadid`}
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </td>

                                                    {/* Amount Field */}
                                                    <td>
                                                        <Field
                                                            name={`dummy_journal_voucher_heads_Req[${index}].debit`}
                                                            className={`form-control ${formik.touched.dummy_journal_voucher_heads_Req?.[index]?.debit &&
                                                                formik.errors.dummy_journal_voucher_heads_Req?.[index]?.debit
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            type="number"
                                                            maxLength={15}
                                                            onKeyPress={(e) => NumberValidation(e)}
                                                            onCopy={(e) => e.preventDefault()}
                                                            onPaste={(e) => e.preventDefault()}
                                                            onCut={(e) => e.preventDefault()}
                                                        />
                                                        <ErrorMessage
                                                            name={`dummy_journal_voucher_heads_Req[${index}].debit`}
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </td>

                                                    {/* Actions */}
                                                    <td>
                                                        <AiFillPlusCircle
                                                            style={{ fontSize: "21px", color: "green", cursor: "pointer" }}
                                                            onClick={() => push({ headid: "", subheadid: "", debit: "" })}
                                                        />
                                                        {index > 0 && (
                                                            <AiFillMinusCircle
                                                                style={{ fontSize: "21px", color: "red", cursor: "pointer", marginLeft: "10px" }}
                                                                onClick={() => remove(index)}
                                                            />
                                                        )}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="3" style={{ textAlign: "right" }}>
                                                    Total
                                                </td>
                                                <td colSpan="2" className="fw-bold">
                                                    ₹
                                                    {formik.values.dummy_journal_voucher_heads_Req
                                                        .reduce((sum, row) => sum + (parseFloat(row.debit) || 0), 0)
                                                        .toFixed(2)}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                )}
                            </FieldArray>
                        </OFMSUI.Row>
                        <OFMSUI.Row className="m-2">
                            <center> <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}> <button className="btn btn-success btn-sm" type="submit"> Submit </button> </OFMSUI.Col> </center>
                        </OFMSUI.Row>
                    </Form>
                </FormikProvider>
            </OFMSUI.Container>
        </>
    )
}

export default GenerationPayment
